export default __webpack_public_path__ + "static/media/ISMO CLASS-5_SYLLABUS_2025-26.ddb264be.pdf";